import { useLogging } from '@ecosystem/newron-client-lib';

const MIN_API_FAILURE_RESPONSE_CODE = 400;
export interface ErrorTag {
  category: ErrorTagEnum;
  requestPayload?: any;
  responseStatus?: number;
  stackTrace?: string;
  clientId?: number;
}
export enum ErrorTagEnum {
  ApiError = 'API_ERROR',
  DataError = 'DATA_ERROR',
  FrontEndError = 'FRONTEND_ERROR',
}
export const getFormattedTags = (e: any, tags: ErrorTag): any => {
  if (e.responseStatus >= MIN_API_FAILURE_RESPONSE_CODE) tags.responseStatus = e.responseStatus;
  return tags;
};

export const saveErrorLog = (e: any, componentMessage: string, tags: ErrorTag) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { error: logError } = useLogging();
  e.message = `${componentMessage} ${e.message}`;
  e.error = e.stack;
  logError(e.error, getFormattedTags(e, tags));
};

export const useSaveErrorLog = () => {
  const { error: logError } = useLogging();

  return (e: any, componentMessage: string, tags: ErrorTag) => {
    e.message = `${componentMessage} ${e.message}`;
    e.error = e.stack;
    logError(e.error, getFormattedTags(e, tags));
  };
};

export default saveErrorLog;
